
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content style="width: 600px; max-height: 90vh;">
  <t4-container title="{{ 'TO.Service.InsuranceInfo.InsuranceCaseMissingInfoTitle' | translate : 'The insurance case is missing information' }}">
    <div class="row">
      <div class="col-12" style="font-size: 15px">
        <div>{{ 'Turbo.Service.CreateServiceRequestDialog.ObligatoryToAttach' | translate : 'For Brenderup to be able process your insurance case we require the following:' }}</div>
      </div>
      <div class="col-12 mt-2">
        <mat-list style="overflow-y: visible; overflow-x: auto; font-weight: bold">
          <mat-list-item style="font-size: 15px !important; color: red" *ngIf="!data.imageUploaded">
            <mat-icon style="margin-right: 5px">error</mat-icon>
            {{ 'TO.Service.InsuranceInfo.PicturesOfDamage' | translate : 'Pictures of eventual damages' }}
          </mat-list-item>
          <mat-list-item style="font-size: 15px !important; color: red" *ngIf="!data.fileUploaded">
            <mat-icon style="margin-right: 5px">error</mat-icon>
            {{ 'TO.Service.InsuranceInfo.DamageReportForm' | translate : 'Damage report form' }}
          </mat-list-item>
          <mat-list-item style="font-size: 15px !important; color: red" *ngIf="false && !data.existingCase">
            <mat-icon style="margin-right: 5px">error</mat-icon>
            {{ 'TO.Service.InsuranceInfo.RecordNumberRequired' | translate : 'Record number from police report if a theft has taken place' }}
          </mat-list-item>
        </mat-list>
      </div>
    </div>
    <div class="loader" *ngIf="loading">
      <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading"></mat-progress-bar>
    </div>
  </t4-container>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <!--<button mat-flat-button color="primary" style="margin: 3px;" (click)="agree()" [disabled]="loading">{{ 'Turbo.Service.CreateServiceRequestDialog.AddLater' | translate : 'Add later' }}</button>-->
    <button mat-flat-button style="margin: 3px;" (click)="cancel()" [disabled]="loading">{{ 'Turbo.Service.CreateServiceRequestDialog.GoBack' | translate : 'Go back and add information' }}</button>
  </div>
</mat-dialog-actions>
